import { useQuery } from '@tanstack/react-query';
import { getDataQuery } from 'api';
import { useState, useEffect } from 'react';

export const useMonitoringQuery = () => {
  const [selectedTermId, setSelectedTermId] = useState(null);
  const [selectedOpenYy, setSelectedOpenYy] = useState(null);
  const [selectedOpenTmGbn, setSelectedOpenTmGbn] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [queryParams, setQueryParams] = useState(null);

  const { data: 학기_목록, isLoading: 학기_로딩 } = useQuery({
    queryKey: ['monitoringTerms'],
    queryFn: () => getDataQuery('/terms?account_id=1'),
  });

  useEffect(() => {
    if (!selectedTermId || !학기_목록) return;
    const terms = 학기_목록?.data ?? 학기_목록 ?? [];
    const selected = terms.find(t => t.id === Number(selectedTermId));
    const sisTermId = selected?.sis_term_id || '';
    setSelectedOpenYy(sisTermId.length >= 4 ? parseInt(sisTermId.substring(0, 4)) : null);
    setSelectedOpenTmGbn(sisTermId.length > 4 ? parseInt(sisTermId.substring(4)) : null);
  }, [selectedTermId, 학기_목록]);

  const { data: 학과_목록, isLoading: 학과_로딩 } = useQuery({
    queryKey: ['monitoringDivisions', selectedOpenYy, selectedOpenTmGbn],
    queryFn: () => getDataQuery(`/admin/monitoring/divisions?openYy=${selectedOpenYy}&openTmGbn=${selectedOpenTmGbn}`),
    enabled: !!selectedOpenYy && !!selectedOpenTmGbn,
  });

  const {
    data: 모니터링_통계,
    isLoading: 모니터링_로딩,
    refetch: 모니터링_조회,
  } = useQuery({
    queryKey: ['monitoringStats', queryParams],
    queryFn: () => {
      const divisionParam = queryParams.division ? `&division=${encodeURIComponent(queryParams.division)}` : '';
      return getDataQuery(`/admin/monitoring?openYy=${queryParams.openYy}&openTmGbn=${queryParams.openTmGbn}${divisionParam}`);
    },
    enabled: !!queryParams?.openYy && !!queryParams?.openTmGbn,
  });

  const handleSearch = () => {
    if (!selectedOpenYy || !selectedOpenTmGbn) return;
    setQueryParams({ openYy: selectedOpenYy, openTmGbn: selectedOpenTmGbn, division: selectedDivision });
  };

  return {
    학기_목록,
    학기_로딩,
    학과_목록,
    학과_로딩,
    모니터링_통계,
    모니터링_로딩,
    selectedTermId,
    setSelectedTermId,
    selectedDivision,
    setSelectedDivision,
    handleSearch,
  };
};
